<template>
  <div>
    <div class="d-flex mb-2">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          SPU：{{ formData.hxSpuNo ? formData.hxSpuNo : '新增' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          class="mr-2"
          style="font-size: 12px"
          :variant="
            formData.hxSpuStatus === 'Y'
              ? 'success'
              : formData.hxSpuStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_hxSpuStatus || '企划' }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form ref="spuForm" :model="formData" :rules="rules" size="mini">
      <el-row :gutter="10">
        <div @click="onImagePreview" class="mr-3">
          <el-image
            style="width: 130px; height: 130px;"
            fit="scale-down"
            :src="formData.defaultImageUrl"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic-square.jpg"
                style="width: 130px; height: 130px;"
              />
            </div>
          </el-image>
        </div>
        <el-col :span="22">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_label_goodsNameCn') || '中文名称'"
                prop="goodsName"
              >
                <el-input
                  v-model="formData.goodsName"
                  clearable
                  size="mini"
                  :placeholder="
                    $l('INDEX.form_placeholder_goodsNameCn') || '请输入产品名称'
                  "
                  maxlength="500"
                  :disabled="disabled"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('INDEX.replenishment_label_goodsNameEn') || '英文名称'
                "
                prop="goodsNameEn"
              >
                <el-input
                  v-model="formData.goodsNameEn"
                  clearable
                  size="mini"
                  :placeholder="
                    $l('INDEX.form_placeholder_goodsNameEn') || '请输入英文名称'
                  "
                  maxlength="500"
                  :disabled="disabled"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.order_form_label_brand') || '品牌'"
                prop="brandCode"
              >
                <dict-select
                  v-model="formData.brandCode"
                  url="/master/common/dict/brandSelect"
                  :placeholder="
                    $l('INDEX.form_label_please_select_brand') || '请选择品牌'
                  "
                  :selectedLabel.sync="formData.brandName"
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                  :disabled="disabled"
                  @change="clearCollection"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.table_label_category') || '分类'"
                prop="categoryCode"
              >
                <CategoryCascader
                  :categoryCode.sync="formData.categoryCode"
                  :categoryName.sync="formData.categoryName"
                  :masterCategoryCode.sync="formData.masterCategoryCode"
                  :masterCategoryName.sync="formData.masterCategoryName"
                  :displayCategoryCode.sync="formData.displayCategoryCode"
                  :displayCategoryName.sync="formData.displayCategoryName"
                  :disabled="disabled"
                  @change="clearCollection"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.isVc') || '是否VC产品'"
                prop="isVc"
              >
                <el-select
                  v-model="formData.isVc"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  filterable
                  clearable
                  size="mini"
                  style="width: 100%"
                  :disabled="disabled"
                  @change="clearCollection"
                >
                  <el-option value="Y" :label="$l('INDEX.YES') || '是'">
                  </el-option>
                  <el-option value="N" :label="$l('INDEX.NO') || '否'">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-form-item :label="''" class="mr-3">
          <br />
          <el-button
            plain
            type="primary"
            style="width:130px"
            @click="spuImageVisible = true"
            :disabled="['detail', 'add'].includes(optType)"
            >{{ $l('form_label_picture_maintenance') || '图片维护' }}</el-button
          >
        </el-form-item>
        <el-col :span="22">
          <el-row :gutter="10" type="flex" justify="end">
            <!-- <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.table_label_succession') || '系列'"
                prop="collectionName"
              >
                <el-input
                  v-model="formData.collectionName"
                  :disabled="disabled"
                  readonly
                >
                  <el-button
                    slot="append"
                    icon="el-icon-more"
                    :disabled="disabled"
                    @click="openChooseCollection"
                  />
                </el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_design') || '企划'"
                prop="designCode"
              >
                <dict-select
                  v-model="formData.designCode"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('INDEX.form_placeholder_design') || '请选择企划人员'
                  "
                  :selectedLabel.sync="formData.designName"
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                  :disabled="disabled"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8"> </el-col>
            <el-col :span="8" class="text-right">
              <el-form-item :label="''">
                <br />
                <el-button
                  v-if="!disabled"
                  type="primary"
                  size="small"
                  @click="save()"
                  style="width: 20%"
                >
                  {{ $l('INDEX.btn_save') || '保存' }}
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>

    <SpuImage
      v-if="spuImageVisible"
      :title="$l('form_label_picture_maintenance') || '图片维护'"
      :visible.sync="spuImageVisible"
      :hxSpuCode="hxSpuCode"
      @reload="getData"
    />

    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listImageUrl"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>

    <ChooseCollection
      v-if="chooseCollectionVisible"
      :visible.sync="chooseCollectionVisible"
      :title="$l('dialog_title_choose_collection') || '系列选择'"
      :form="formData"
      @confirm="updateCollection"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'

import CategoryCascader from '../category-cascader'
import SpuImage from './spu-image'
import ChooseCollection from './choose-collection'
export default {
  mixins: [EditLoading],
  components: { CategoryCascader, SpuImage, ChooseCollection },
  props: {
    hxSpuCode: { type: String, default: '' },
    hxSpuStatus: { type: String, default: '' },
    optType: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      rules: {
        goodsName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        goodsNameEn: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
              if (!reg.test(value)) {
                callback()
              } else {
                callback(
                  new Error(
                    this.$l('INDEX.form_placeholder_goodsNameEn_noChina') ||
                      '英文名称不能存在中文'
                  )
                )
              }
            },
          },
        ],
        brandCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        collectionName: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        categoryCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        designCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        isVc: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
      spuImageVisible: false,
      chooseCollectionVisible: false,
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
    disabled() {
      return ['detail', 'addSku'].includes(this.optType)
    },
    isEmpty() {
      return !this.formData.listImageUrl || !this.formData.listImageUrl.length
    },
    listImageUrl() {
      return this.isEmpty
        ? []
        : this.formData.listImageUrl.map((item) => item.displayImageUrl)
    },
  },
  watch: {
    info: {
      handler(userInfo) {
        if (this.hxSpuCode) return
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.designCode = userCode || ''
        this.formData.designName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.hxSpuCode) return
      this.$api
        .ecomHxSpuDetailApi({
          hxSpuCode: this.hxSpuCode,
        })
        .then((res) => {
          const data = res.body
          this.formData = { ...data }
          const { hxSpuStatus } = data
          this.$emit('update:hxSpuStatus', hxSpuStatus)
        })
    },
    onImagePreview() {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.imagesViewer').$viewer

      const index = this.formData.listImageUrl.findIndex(
        (item) => item.displayImageUrl === this.formData.defaultImageUrl
      )
      viewer.view(index)
      viewer.show()
    },
    async save() {
      const result = await validate.formValidate([this.$refs.spuForm])
      if (!result) return
      this.loadingOpen()
      const res = await this.$api
        .ecomHxSpuSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      const { hxSpuCode = '', hxSpuNo = '' } = body || {}
      if (this.optType === 'add' && hxSpuCode) {
        this.$router.replace({
          name: 'ecom-base-hxSpu-detail',
          params: { hxSpuCode, pageType: 'edit' },
          query: { hxSpuNo },
        })
        return
      }
      this.getData()
    },
    openChooseCollection() {
      const { brandCode, categoryCode, isVc } = this.formData
      if (!brandCode || !categoryCode || !isVc) {
        this.$message({
          message: '请先选择品牌、品类、是否VC产品',
          type: 'warning',
        })
        return
      }
      this.chooseCollectionVisible = true
    },
    updateCollection(data) {
      this.$refs.spuForm.clearValidate('collectionName')
      const { value = '', label = '' } = data
      this.formData = {
        ...this.formData,
        collectionNo: value,
        collectionName: label,
      }
    },
    clearCollection() {
      this.formData.collectionNo = ''
      this.formData.collectionName = ''
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}

.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.el-row {
  display: flex;
  align-items: stretch;
}
.image-col {
  padding: 0;
}
.image-wrapper {
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-wrapper img {
  max-width: 100%;
  max-height: 100%;
}
.text-col {
  padding: 0;
}
.text-wrapper {
  padding: 20px;
}
</style>
